package org.example.zone360.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import kotlinx.browser.localStorage
import kotlinx.coroutines.delay
import kotlinx.datetime.Clock
import kotlinx.datetime.internal.JSJoda.DateTimeFormatter
import kotlinx.datetime.internal.JSJoda.LocalDate
import kotlinx.datetime.internal.JSJoda.ZoneOffset
import kotlinx.datetime.toLocalDateTime
import org.example.zone360.models.Payment
import org.example.zone360.utils.Constants.EMAIL_REGEX
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import kotlin.math.roundToInt


val emojiMap = mapOf(
    "sad" to "\uD83D\uDE25",       // 😥
    "sadness" to "\uD83D\uDE25",       // 😥
    "frustrated" to "\uD83D\uDE21", // 😡
    "frustration" to "\uD83D\uDE21", // 😡
    "polite" to "\uD83D\uDE0C",    // 😌
    "impolite" to "\uD83D\uDE20",  // 😠
    "sympathetic" to "\uD83E\uDD17", // 🤗
    "satisfied" to "\uD83D\uDE0A", // 😊
    "excited" to "\uD83E\uDD29",   // 🤩
    "Excited" to "\uD83E\uDD29",   // 🤩
    "joy" to "\uD83E\uDD29",   // 🤩
    "positive" to "\uD83D\uDE0A", // 😊
    "negative" to "\uD83D\uDE41", // 🙁
    "negative" to "\uD83D\uDE41", // 🙁
    "neutral" to "\uD83D\uDE10",   // 😐
    "Neutral" to "\uD83D\uDE10",   // 😐
    "fear" to "\uD83D\uDE31",   //
    "informative" to "\uD83E\uDD13",   //
)
fun cleanHtmlString(rawHtml: String): String {
    return rawHtml
        .replace("\\n", "\n")
        .replace("\\\"", "\"")
        .replace("\\'", "'")
        .replace("\\t", "\t")
}

fun extractContentText(rawHtml: String): String {
    val cleanedHtml = cleanHtmlString(rawHtml)
    val start = cleanedHtml.indexOf("""<div class="content">""")
    val end = cleanedHtml.indexOf("</div>", start)

    if (start != -1 && end != -1) {
        var contentBlock = cleanedHtml.substring(start, end + "</div>".length)

        // Replace <a href="...">text</a> based on type
        contentBlock = contentBlock.replace(Regex("""<a\s+href=["']([^"']+)["'][^>]*>(.*?)</a>""")) {
            val href = it.groupValues[1]
            val linkText = it.groupValues[2]

            if (href.startsWith("mailto:")) {
                if (href.removePrefix("mailto:") == linkText.trim()) {
                    linkText
                } else {
                    "$linkText : $href"
                }
            } else {
                "$linkText : $href"
            }
        }

        // Replace basic HTML tags with formatting
        return contentBlock
            .replace("<br>", "\n")
            .replace("<br/>", "\n")
            .replace("</p>", "\n")
            .replace("</li>", "\n")
            .replace("<li>", "- ")
            .replace(Regex("<[^>]*>"), "") // strip all remaining tags
            .replace("&nbsp;", " ")
            .replace("&amp;", "&")
            .lines()
            .map { it.trim() }
            .filter { it.isNotEmpty() }
            .joinToString("\n\n")
            .trim()
    }

    return "Message not found."


}

fun Double.toFixed(digits: Int): String {
    return (this.asDynamic()).toFixed(digits) as String
}
fun getEmoji(className: String): String {
    return emojiMap[className.lowercase()] ?: "\uD83D\uDE42" // Default to  if no match
}
    fun isValidEmail(email: String): Boolean {
        return email.matches(EMAIL_REGEX.toRegex())
    }
fun sanitizeFileNameForBlob(fileName: String): String {
    return fileName
        .replace(" ", "_")
        .replace("'", "")
        .replace(":", "")
        .replace("&", "and")
    // Add more if needed
}
fun Modifier.noBorder(): Modifier {
    return this.border(
        width = 0.px,
        style = LineStyle.None,
        color = Colors.Transparent
    ).outline(
        width = 0.px,
        style = LineStyle.None,
        color = Colors.Transparent
    )
}


//
fun saveToLocalStorage(key: String, value: Any) {
    localStorage.setItem(key, value.toString())
}


fun getFromLocalStorage(key: String): String {
    return localStorage.getItem(key) ?: ""
}
fun String.extractTeamName(): String = this.substringBefore("_")

fun isBeforeCutoff(paidOn: String): Boolean {
    val paidDate = paidOn.take(10) // "2025-08-07"
    return paidDate < "2026-04-13"
}

fun normalizeText(input: String): String {
    return input.trim().replace(Regex("\\s+"), " ")
}


//
fun getCurrentMilliseconds(): Long {
    return Clock.System.now().toEpochMilliseconds()
}

fun dateToMillis(date: String): Long {
    if (date.length != 8 || !date.all { it.isDigit() }) return 0L

    val iso = "${date.substring(0,4)}-" +
            "${date.substring(4,6)}-" +
            "${date.substring(6,8)}T00:00:00Z"

    return (js("new Date(iso).getTime()") as Double).toLong()
}


fun formatInvoiceDate(dateString: String): String {
    return try {
        if (dateString == "0" || dateString.isBlank()) return "" // or ""
        val inputFormatter = DateTimeFormatter.ofPattern("yyyyMMdd")
        val outputFormatter = DateTimeFormatter.ofPattern("yyyy-MM-dd")
        LocalDate.parse(dateString, inputFormatter).format(outputFormatter)
    } catch (e: Exception) {
        "" // fallback if somehow malformed
    }
}




@Composable
fun roundToTwoDecimalPlaces(value: Double? = 0.0): Double {
    return (value!! * 100.0).roundToInt() / 100.0
}
fun Double.toMoney(decimals: Int = 2): String {
    return this.asDynamic().toFixed(decimals) as String
}


fun String.isEmptyFeild(): Boolean {
    val trimmed = this.trim()
    return trimmed.isEmpty() || trimmed.matches(Regex("^[a-zA-Z]+$"))
}

fun String.isEmptyWeightHeight(): Boolean {
    val trimmed = this.trim()
    if (trimmed.isBlank()) return true

    if (trimmed.matches(Regex("^[a-zA-Z]+$"))) return true

    return false
}


@Composable
fun     Divider(modifier: Modifier = Modifier) {
    HorizontalDivider(
        modifier = modifier.height(1.px).fillMaxWidth().padding (all = 0.px).margin(all = 0.px)
            .backgroundColor(Colors.AliceBlue)
    )
}

fun formatSeasonDate(date: String): String {

    return try {

        val localDate =
            kotlinx.datetime.Instant
                .parse(date)
                .toLocalDateTime(
                    kotlinx.datetime.TimeZone.UTC
                )

        val month =
            localDate.month.name
                .lowercase()
                .replaceFirstChar {
                    it.uppercase()
                }

        "Created $month ${localDate.year}"

    } catch (e: Exception) {
        ""
    }
}

fun formatUpdatedAt(updatedAt: String): String {
    // updatedAt = "2026-06-02T12:07:47.759040Z"
    return try {
        val date = updatedAt.substringBefore("T")
        val parts = date.split("-")
        val year = parts[0]
        val month = when (parts[1]) {
            "01" -> "Jan"; "02" -> "Feb"; "03" -> "Mar"; "04" -> "Apr"
            "05" -> "May"; "06" -> "Jun"; "07" -> "Jul"; "08" -> "Aug"
            "09" -> "Sep"; "10" -> "Oct"; "11" -> "Nov"; "12" -> "Dec"
            else -> parts[1]
        }
        val day = parts[2].trimStart('0')
        "$day $month $year"
    } catch (e: Exception) {
        ""
    }
}
